import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Keyboard shortcuts for board column focus. Focusing a column is otherwise a
// two-click trip through the header panel, and the whole point of focus mode is
// working one list at a time — so stepping between lists and getting back out
// stay on the keyboard.
//
//   [ / ]   focus the previous / next column
//   Escape  leave focus mode
//
// Every URL is rendered server-side (they carry the board's current filters),
// so this controller only picks one and visits it.
export default class extends Controller {
  static values = {
    focusUrls: Array,
    focusedIndex: Number,
    unfocusUrl: String,
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    window.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    window.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    if (this.isTyping(event.target)) return

    switch (event.key) {
      case "[":
        this.step(-1, event)
        break
      case "]":
        this.step(1, event)
        break
      case "Escape":
        if (this.focusedIndexValue < 0) return
        event.preventDefault()
        Turbo.visit(this.unfocusUrlValue)
        break
    }
  }

  // From no focus, either direction enters at the nearest end, so a single
  // keypress gets you into focus mode. Stepping past either end stops there
  // rather than wrapping — wrapping in a spatial list loses your place.
  step(direction, event) {
    const urls = this.focusUrlsValue
    if (urls.length === 0) return

    const current = this.focusedIndexValue
    let next
    if (current < 0) {
      next = direction > 0 ? 0 : urls.length - 1
    } else {
      next = current + direction
      if (next < 0 || next >= urls.length) return
    }

    event.preventDefault()
    Turbo.visit(urls[next])
  }

  isTyping(target) {
    if (!target) return false
    const tag = target.tagName
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target.isContentEditable
  }
}
